<template>
    <button
        v-b-tooltip.hover.top
        title="Download"
        class="btn btn-icon"
        @click="submit" :class="buttonClass"
        :disabled="disable"
        :data-test="'download-button-' + downloadType"
    >
        <i class="fal fa-arrow-alt-to-bottom fa-fw"></i>
        <span class="sr-only">Download Order Item</span>
    </button>
</template>

<script>
import { Query } from '@jgile/laravel-vue';

export default {
    props: {
        query: {
            required: false,
            default: null,
        },
        downloadType: {
            required: true,
        },
        buttonClass: {
            type: String,
            default: null,
        },
        disable: {
            default: false,
        },
    },

    methods: {
        submit() {
            new Query(this.query).post(`/api/orders/download/${this.downloadType}`);
        },
    },
};
</script>
